import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ user, children, loading }) {
  if (loading) return null; // or a spinner
  if (!user) return <Navigate to="/signin" replace />;
  return children;
}
